<template>
  <div>
    <PopupSearchWidget
      :title="$t('account.search')"
      :width="800"
      :action="handleSearchAccount"
      :columns="columns"
      :selectedRowTitle="accountName"
      :selectedRowId="accountId"
      :defaultData="accounts"
      @on-select="handleAccountChanged">
    </PopupSearchWidget>
    <div class="text-align-right" style="font-size: 12px; color: rgb(128, 134, 149);">
      <router-link v-if="accountId" :to="{ name: `menu.account.edit_account`, params: { 'accountId': accountId } }" target="_blank">{{ $t('account.click_to_access_account_info_message') }}</router-link>
    </div>
  </div>
</template>

<script>
import PopupSearchWidget from '@/components/search/popup-select-widget'
import { eloquentsearch } from '@/api/search'
export default {
  name: 'AccountSearchAndPick',
  props: {
    account: {
      type: Object,
      required: false
    }
  },
  components: {
    PopupSearchWidget
  },
  data() {
    return {
      columns: [
        { type: 'radio', field: 'id', title: 'ID', width: 80 },
        { field: 'crm_id', title: 'CRM ID', width: 120 },
        { field: 'account_number', title: 'Account number', width: 120, remoteSort: false },
        { field: 'name', title: 'Name', width: 450, remoteSort: false },
        { field: 'country_code', title: 'Country code', width: 80, remoteSort: false }
      ]
    }
  },
  computed: {
    accounts: function () {
      return this.account ? [this.account] : []
    },
    accountName: function () {
      let name = this.account ? this.account.name : ''

      if (name && this.account.account_number) {
        name = name + ` (${this.account.account_number})`
      }

      return name
    },
    accountId: function () {
      return this.account ? this.account.id : null
    }
  },
  methods: {
    eloquentsearch,
    async handleSearchAccount (keyword) {
      let result = await eloquentsearch('account', keyword)
      return result.data.data
    },
    handleAccountChanged(account) {
      this.$emit('input', account.id)
      this.$emit('update:account', account)
      this.$emit('on-account-changed', account) // will be removed, use above emits
    }
  }
}
</script>
